import React from 'react';

export const LogoGraphic = ({ accentColor, className = "w-10 h-10" }) => (
  <svg viewBox="0 0 100 100" className={`${className} -skew-x-12`}>
    <path d="M20 80 L20 20 L40 20 L80 80 L80 20" fill="none" stroke="white" strokeWidth="12" strokeLinecap="square" strokeLinejoin="miter" />
    <path d="M80 20 L80 35" fill="none" stroke={accentColor} strokeWidth="12" strokeLinecap="square" />
  </svg>
);
